(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cod-art"] && !Shopify.designMode) return;
  try {
    
/* COD Art lander — bundle selection, COD form validation + thank-you state,
   cart wiring (add.js → cart attributes → /checkout), FAQ accordion.
   Countdowns are handled by panelverse.js ([data-countdown-to] contract). */
(function () {
  'use strict';

  function initCodArt(root) {
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-codart-bundle]'));
    var totalEl = root.querySelector('[data-codart-total]');
    var submitBtn = root.querySelector('[data-codart-submit]');
    var noProductNote = root.querySelector('[data-codart-noproduct]');
    var errEl = root.querySelector('[data-codart-error]');
    var nameEl = root.querySelector('[data-codart-name]');
    var phoneEl = root.querySelector('[data-codart-phone]');
    var addrEl = root.querySelector('[data-codart-addr]');
    var formWrap = root.querySelector('[data-codart-form]');
    var thanksEl = root.querySelector('[data-codart-thanks]');
    var sticky = root.querySelector('[data-codart-sticky]');
    var submitting = false;

    function selectedBundle() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return bundles[0] || null;
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.classList.toggle('is-visible', !!msg);
    }

    function clearError() {
      showError('');
      var fields = [nameEl, phoneEl, addrEl];
      for (var i = 0; i < fields.length; i++) {
        if (fields[i]) fields[i].classList.remove('is-invalid');
      }
    }

    function syncSelection() {
      var sel = selectedBundle();
      if (!sel) {
        if (submitBtn) submitBtn.disabled = true;
        return;
      }
      if (totalEl) totalEl.textContent = sel.getAttribute('data-price') || '';
      var hasProduct = !!sel.getAttribute('data-variant-id');
      if (submitBtn && !submitting) submitBtn.disabled = !hasProduct;
      if (noProductNote) noProductNote.hidden = hasProduct;
    }

    function selectBundle(el) {
      for (var i = 0; i < bundles.length; i++) {
        var on = bundles[i] === el;
        bundles[i].classList.toggle('is-selected', on);
        bundles[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      clearError();
      syncSelection();
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () { selectBundle(b); });
      b.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
          ev.preventDefault();
          selectBundle(b);
        }
      });
    });

    [nameEl, phoneEl, addrEl].forEach(function (el) {
      if (el) el.addEventListener('input', clearError);
    });

    function submitOrder() {
      if (submitting) return;
      var name = nameEl ? nameEl.value.trim() : '';
      var phoneRaw = phoneEl ? phoneEl.value.trim() : '';
      var phone = phoneRaw.replace(/[- ]/g, '');
      var addr = addrEl ? addrEl.value.trim() : '';

      var nameOk = name.length >= 3;
      var phoneOk = /^0[0-9]{8,9}$/.test(phone);
      var addrOk = addr.length >= 12;

      if (nameEl) nameEl.classList.toggle('is-invalid', !nameOk);
      if (phoneEl) phoneEl.classList.toggle('is-invalid', !phoneOk);
      if (addrEl) addrEl.classList.toggle('is-invalid', !addrOk);

      if (!(nameOk && phoneOk && addrOk)) {
        showError(root.getAttribute('data-msg-invalid') || '');
        return;
      }

      var sel = selectedBundle();
      if (!sel) return;
      var variantId = Number(sel.getAttribute('data-variant-id'));
      if (!variantId) { syncSelection(); return; }
      var qty = Number(sel.getAttribute('data-qty')) || 1;

      var addUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
      var updateUrl = (root.getAttribute('data-cart-update-url') || '/cart/update') + '.js';
      var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

      var originalLabel = submitBtn ? submitBtn.textContent : '';
      submitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = root.getAttribute('data-msg-wait') || originalLabel;
      }
      clearError();

      fetch(addUrl, {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        })
        .then(function () {
          return fetch(updateUrl, {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
              attributes: {
                'ชื่อผู้รับ': name,
                'เบอร์โทร': phoneRaw,
                'ที่อยู่จัดส่ง': addr
              }
            })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart update failed');
          return res.json();
        })
        .then(function () {
          if (window.Panelverse && window.Panelverse.refreshCartCount) {
            window.Panelverse.refreshCartCount();
          }
          if (formWrap) formWrap.style.display = 'none';
          if (thanksEl) thanksEl.classList.add('is-visible');
          if (sticky) sticky.classList.add('is-hidden');
          setTimeout(function () { window.location.href = '/checkout'; }, 1200);
        })
        .catch(function () {
          submitting = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
          showError(root.getAttribute('data-msg-cart-error') || '');
        });
    }

    if (submitBtn) submitBtn.addEventListener('click', submitOrder);

    /* FAQ accordion — one open at a time, +/− icon (concept behavior) */
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-codart-faq]'));
    faqItems.forEach(function (item) {
      var toggle = item.querySelector('[data-codart-faq-toggle]');
      var answer = item.querySelector('[data-codart-faq-answer]');
      var icon = item.querySelector('[data-codart-faq-icon]');
      if (!toggle || !answer) return;
      toggle.addEventListener('click', function () {
        var willOpen = answer.hidden;
        faqItems.forEach(function (other) {
          var oAnswer = other.querySelector('[data-codart-faq-answer]');
          var oIcon = other.querySelector('[data-codart-faq-icon]');
          var oToggle = other.querySelector('[data-codart-faq-toggle]');
          if (oAnswer) oAnswer.hidden = true;
          if (oIcon) oIcon.textContent = '+';
          if (oToggle) oToggle.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          answer.hidden = false;
          if (icon) icon.textContent = '−';
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    syncSelection();
  }

  function init() {
    var roots = document.querySelectorAll('[data-codart-root]');
    for (var i = 0; i < roots.length; i++) initCodArt(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-cat"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCodcat(root) {
    if (root.hasAttribute('data-codcat-init')) return;
    root.setAttribute('data-codcat-init', '');

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-codcat-bundle]'));
    var submitBtn = root.querySelector('[data-codcat-submit]');
    var totalEl = root.querySelector('[data-codcat-total]');
    var errEl = root.querySelector('[data-codcat-error]');
    var errNetEl = root.querySelector('[data-codcat-error-net]');
    var noProductEl = root.querySelector('[data-codcat-noproduct]');
    var formCard = root.querySelector('[data-codcat-formcard]');
    var thanksEl = root.querySelector('[data-codcat-thanks]');
    var nameInput = root.querySelector('[data-codcat-name]');
    var phoneInput = root.querySelector('[data-codcat-phone]');
    var addrInput = root.querySelector('[data-codcat-addr]');

    function selectedBundle() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return null;
    }

    function selectBundle(key) {
      var found = null;
      bundles.forEach(function (b) {
        var match = b.getAttribute('data-bundle-key') === key;
        b.classList.toggle('is-selected', match);
        if (match) found = b;
      });
      if (found && totalEl) totalEl.textContent = found.getAttribute('data-price') || '';
      refreshSubmitState();
    }

    function refreshSubmitState() {
      if (!submitBtn) return;
      var sel = selectedBundle();
      var hasVariant = !!(sel && sel.getAttribute('data-variant-id'));
      submitBtn.disabled = !hasVariant;
      if (noProductEl) noProductEl.hidden = hasVariant;
    }

    // default selection: popular block, else first (concept default = b2)
    var initial = null;
    bundles.forEach(function (b) { if (b.hasAttribute('data-popular')) initial = b; });
    if (!initial && bundles.length) initial = bundles[0];
    if (initial) selectBundle(initial.getAttribute('data-bundle-key'));

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        hideErrors();
        selectBundle(b.getAttribute('data-bundle-key'));
      });
    });

    // bundle-card "เลือกแพ็กนี้" buttons
    root.addEventListener('click', function (ev) {
      var pick = ev.target && ev.target.closest ? ev.target.closest('[data-codcat-pick]') : null;
      if (pick) selectBundle(pick.getAttribute('data-bundle-key'));
    });

    function hideErrors() {
      if (errEl) errEl.hidden = true;
      if (errNetEl) errNetEl.hidden = true;
    }

    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        hideErrors();
      });
    });

    // FAQ accordion (one open at a time, concept behavior)
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-codcat-faq]'));
    faqItems.forEach(function (item) {
      var head = item.querySelector('[data-codcat-faq-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var a = other.querySelector('.codcat-faq__a');
          var icon = other.querySelector('.codcat-faq__icon');
          var btn = other.querySelector('[data-codcat-faq-toggle]');
          if (a) a.hidden = true;
          if (icon) icon.textContent = '+';
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          var a = item.querySelector('.codcat-faq__a');
          var icon = item.querySelector('.codcat-faq__icon');
          if (a) a.hidden = false;
          if (icon) icon.textContent = '−';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });

    function showThanks() {
      root.classList.add('is-ordered');
      if (formCard) formCard.hidden = true;
      if (thanksEl) {
        thanksEl.hidden = false;
        var phoneSpan = thanksEl.querySelector('[data-codcat-confirm-phone]');
        var totalSpan = thanksEl.querySelector('[data-codcat-confirm-total]');
        if (phoneSpan && phoneInput) phoneSpan.textContent = phoneInput.value;
        if (totalSpan && totalEl) totalSpan.textContent = totalEl.textContent;
      }
    }

    var resetEl = root.querySelector('[data-codcat-reset]');
    if (resetEl) {
      resetEl.addEventListener('click', function () {
        root.classList.remove('is-ordered');
        if (formCard) formCard.hidden = false;
        if (thanksEl) thanksEl.hidden = true;
        if (nameInput) nameInput.value = '';
        if (phoneInput) phoneInput.value = '';
        if (addrInput) addrInput.value = '';
        hideErrors();
        if (submitBtn) {
          submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
          refreshSubmitState();
        }
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        hideErrors();

        var nameOk = nameInput && nameInput.value.trim().length >= 3;
        var phoneOk = phoneInput && /^0\d{8,9}$/.test(phoneInput.value.replace(/[- ]/g, ''));
        var addrOk = addrInput && addrInput.value.trim().length >= 15;

        if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
        if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
        if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);

        if (!nameOk || !phoneOk || !addrOk) {
          if (errEl) errEl.hidden = false;
          return;
        }

        var sel = selectedBundle();
        var variantId = sel && sel.getAttribute('data-variant-id');
        if (!variantId) {
          if (noProductEl) noProductEl.hidden = false;
          return;
        }

        // theme editor: demo the concept thank-you state, no cart mutation
        if (window.Shopify && window.Shopify.designMode) {
          showThanks();
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-label-loading') || submitBtn.textContent;

        var attributes = {
          'ชื่อผู้รับ': nameInput.value.trim(),
          'เบอร์โทร': phoneInput.value.trim(),
          'ที่อยู่จัดส่ง': addrInput.value.trim(),
          'หมายเหตุ': 'แพ็กเกจ: ' + (sel.getAttribute('data-label') || '')
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: Number(sel.getAttribute('data-qty')) || 1 }]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attributes })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('update failed');
            if (window.Panelverse && window.Panelverse.refreshCartCount) window.Panelverse.refreshCartCount();
            window.location.href = '/checkout';
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
            if (errNetEl) errNetEl.hidden = false;
          });
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-codcat-root]');
    for (var i = 0; i < roots.length; i++) initCodcat(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-frozen"] && !Shopify.designMode) return;
  try {
    
/* Smooth-scroll every [data-scroll-form] CTA to the COD order form section.
   Target resolution order:
     1. the section id set in "Order form section ID" (data-form-section)
     2. #codfz-order
     3. the first [data-codfz-formcard] on the page
   If none of those exist the click falls through to the plain anchor. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-scroll-form]');
  if (!btn) return;

  var root = btn.closest('[data-codfz-root]');
  var sectionId = root ? (root.getAttribute('data-form-section') || '') : '';

  var target = null;
  if (sectionId) {
    target = document.getElementById(sectionId) || document.getElementById('shopify-section-' + sectionId);
  }
  if (!target) target = document.getElementById('codfz-order');
  if (!target) target = document.querySelector('[data-codfz-formcard]');
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* COD Frozen lander — bundle selection, FAQ accordion, COD form.
   Every lookup is null-guarded, so the same script works whether the order form
   lives in this section or in its own section.
   Countdowns are handled by the shared panelverse.js [data-countdown-to]. */
(function () {
  'use strict';

  function initCodfz(root) {
    if (root.hasAttribute('data-codfz-init')) return;
    root.setAttribute('data-codfz-init', '');

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-codfz-bundle]'));
    var submitBtn = root.querySelector('[data-codfz-submit]');
    var totalEl = root.querySelector('[data-codfz-total]');
    var errEl = root.querySelector('[data-codfz-error]');
    var errNetEl = root.querySelector('[data-codfz-error-net]');
    var noProductEl = root.querySelector('[data-codfz-noproduct]');
    var formCard = root.querySelector('[data-codfz-formcard]');
    var thanksEl = root.querySelector('[data-codfz-thanks]');
    var nameInput = root.querySelector('[data-codfz-name]');
    var phoneInput = root.querySelector('[data-codfz-phone]');
    var addrInput = root.querySelector('[data-codfz-addr]');

    function selectedBundle() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return null;
    }

    function selectBundle(key) {
      var found = null;
      bundles.forEach(function (b) {
        var match = b.getAttribute('data-bundle-key') === key;
        b.classList.toggle('is-selected', match);
        if (match) found = b;
      });
      if (found && totalEl) totalEl.textContent = found.getAttribute('data-price') || '';
      refreshSubmitState();
    }

    function refreshSubmitState() {
      if (!submitBtn) return;
      var sel = selectedBundle();
      var hasVariant = !!(sel && sel.getAttribute('data-variant-id'));
      submitBtn.disabled = !hasVariant;
      if (noProductEl) noProductEl.hidden = hasVariant;
    }

    // default selection: popular block, else first (concept default = b2)
    var initial = null;
    bundles.forEach(function (b) { if (b.hasAttribute('data-popular')) initial = b; });
    if (!initial && bundles.length) initial = bundles[0];
    if (initial) selectBundle(initial.getAttribute('data-bundle-key'));

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        hideErrors();
        selectBundle(b.getAttribute('data-bundle-key'));
      });
    });

    // bundle-card "เลือกแพ็กนี้" buttons
    root.addEventListener('click', function (ev) {
      var pick = ev.target && ev.target.closest ? ev.target.closest('[data-codfz-pick]') : null;
      if (pick) selectBundle(pick.getAttribute('data-bundle-key'));
    });

    function hideErrors() {
      if (errEl) errEl.hidden = true;
      if (errNetEl) errNetEl.hidden = true;
    }

    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        hideErrors();
      });
    });

    // FAQ accordion (one open at a time, concept behavior)
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-codfz-faq]'));
    faqItems.forEach(function (item) {
      var head = item.querySelector('[data-codfz-faq-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var a = other.querySelector('.codfz-faq__a');
          var icon = other.querySelector('.codfz-faq__icon');
          var btn = other.querySelector('[data-codfz-faq-toggle]');
          if (a) a.hidden = true;
          if (icon) icon.textContent = '+';
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          var a = item.querySelector('.codfz-faq__a');
          var icon = item.querySelector('.codfz-faq__icon');
          if (a) a.hidden = false;
          if (icon) icon.textContent = '−';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });

    function showThanks() {
      root.classList.add('is-ordered');
      if (formCard) formCard.hidden = true;
      if (thanksEl) {
        thanksEl.hidden = false;
        var phoneSpan = thanksEl.querySelector('[data-codfz-confirm-phone]');
        var totalSpan = thanksEl.querySelector('[data-codfz-confirm-total]');
        if (phoneSpan && phoneInput) phoneSpan.textContent = phoneInput.value;
        if (totalSpan && totalEl) totalSpan.textContent = totalEl.textContent;
      }
    }

    var resetEl = root.querySelector('[data-codfz-reset]');
    if (resetEl) {
      resetEl.addEventListener('click', function () {
        root.classList.remove('is-ordered');
        if (formCard) formCard.hidden = false;
        if (thanksEl) thanksEl.hidden = true;
        if (nameInput) nameInput.value = '';
        if (phoneInput) phoneInput.value = '';
        if (addrInput) addrInput.value = '';
        hideErrors();
        if (submitBtn) {
          submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
          refreshSubmitState();
        }
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        hideErrors();

        var nameOk = nameInput && nameInput.value.trim().length >= 3;
        var phoneOk = phoneInput && /^0\d{8,9}$/.test(phoneInput.value.replace(/[- ]/g, ''));
        var addrOk = addrInput && addrInput.value.trim().length >= 15;

        if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
        if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
        if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);

        if (!nameOk || !phoneOk || !addrOk) {
          if (errEl) errEl.hidden = false;
          return;
        }

        var sel = selectedBundle();
        var variantId = sel && sel.getAttribute('data-variant-id');
        if (!variantId) {
          if (noProductEl) noProductEl.hidden = false;
          return;
        }

        // theme editor: demo the concept thank-you state, no cart mutation
        if (window.Shopify && window.Shopify.designMode) {
          showThanks();
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-label-loading') || submitBtn.textContent;

        var attributes = {
          'ชื่อผู้รับ': nameInput.value.trim(),
          'เบอร์โทร': phoneInput.value.trim(),
          'ที่อยู่จัดส่ง': addrInput.value.trim(),
          'หมายเหตุ': 'แพ็กเกจ: ' + (sel.getAttribute('data-label') || '')
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: Number(sel.getAttribute('data-qty')) || 1 }]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attributes })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('update failed');
            if (window.Panelverse && window.Panelverse.refreshCartCount) window.Panelverse.refreshCartCount();
            window.location.href = '/checkout';
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
            if (errNetEl) errNetEl.hidden = false;
          });
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-codfz-root]');
    for (var i = 0; i < roots.length; i++) initCodfz(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-harrypotter"] && !Shopify.designMode) return;
  try {
    
/* Smooth-scroll every [data-scroll-form] CTA to the COD order form section.
   Target resolution order:
     1. the section id set in "Order form section ID" (data-form-section)
     2. #codhp-order
     3. the first [data-codhp-formcard] on the page
   If none of those exist the click falls through to the plain anchor. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-scroll-form]');
  if (!btn) return;

  var root = btn.closest('[data-codhp-root]');
  var sectionId = root ? (root.getAttribute('data-form-section') || '') : '';

  var target = null;
  if (sectionId) {
    target = document.getElementById(sectionId) || document.getElementById('shopify-section-' + sectionId);
  }
  if (!target) target = document.getElementById('codhp-order');
  if (!target) target = document.querySelector('[data-codhp-formcard]');
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* COD Harry Potter lander bundle selection, FAQ accordion, COD form.
   Every lookup is null-guarded, so the same script works whether the order form
   lives in this section or in its own section.
   Countdowns are handled by the shared panelverse.js [data-countdown-to]. */
(function () {
  'use strict';

  function initCodhp(root) {
    if (root.hasAttribute('data-codhp-init')) return;
    root.setAttribute('data-codhp-init', '');

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-codhp-bundle]'));
    var submitBtn = root.querySelector('[data-codhp-submit]');
    var totalEl = root.querySelector('[data-codhp-total]');
    var errEl = root.querySelector('[data-codhp-error]');
    var errNetEl = root.querySelector('[data-codhp-error-net]');
    var noProductEl = root.querySelector('[data-codhp-noproduct]');
    var formCard = root.querySelector('[data-codhp-formcard]');
    var thanksEl = root.querySelector('[data-codhp-thanks]');
    var nameInput = root.querySelector('[data-codhp-name]');
    var phoneInput = root.querySelector('[data-codhp-phone]');
    var addrInput = root.querySelector('[data-codhp-addr]');

    function selectedBundle() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return null;
    }

    function selectBundle(key) {
      var found = null;
      bundles.forEach(function (b) {
        var match = b.getAttribute('data-bundle-key') === key;
        b.classList.toggle('is-selected', match);
        if (match) found = b;
      });
      if (found && totalEl) totalEl.textContent = found.getAttribute('data-price') || '';
      refreshSubmitState();
    }

    function refreshSubmitState() {
      if (!submitBtn) return;
      var sel = selectedBundle();
      var hasVariant = !!(sel && sel.getAttribute('data-variant-id'));
      submitBtn.disabled = !hasVariant;
      if (noProductEl) noProductEl.hidden = hasVariant;
    }

    // default selection: popular block, else first (concept default = b2)
    var initial = null;
    bundles.forEach(function (b) { if (b.hasAttribute('data-popular')) initial = b; });
    if (!initial && bundles.length) initial = bundles[0];
    if (initial) selectBundle(initial.getAttribute('data-bundle-key'));

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        hideErrors();
        selectBundle(b.getAttribute('data-bundle-key'));
      });
    });

    // bundle-card "เลือกแพ็กนี้" buttons
    root.addEventListener('click', function (ev) {
      var pick = ev.target && ev.target.closest ? ev.target.closest('[data-codhp-pick]') : null;
      if (pick) selectBundle(pick.getAttribute('data-bundle-key'));
    });

    function hideErrors() {
      if (errEl) errEl.hidden = true;
      if (errNetEl) errNetEl.hidden = true;
    }

    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        hideErrors();
      });
    });

    // FAQ accordion (one open at a time, concept behavior)
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-codhp-faq]'));
    faqItems.forEach(function (item) {
      var head = item.querySelector('[data-codhp-faq-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var a = other.querySelector('.codhp-faq__a');
          var icon = other.querySelector('.codhp-faq__icon');
          var btn = other.querySelector('[data-codhp-faq-toggle]');
          if (a) a.hidden = true;
          if (icon) icon.textContent = '+';
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          var a = item.querySelector('.codhp-faq__a');
          var icon = item.querySelector('.codhp-faq__icon');
          if (a) a.hidden = false;
          if (icon) icon.textContent = '−';
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });

    function showThanks() {
      root.classList.add('is-ordered');
      if (formCard) formCard.hidden = true;
      if (thanksEl) {
        thanksEl.hidden = false;
        var phoneSpan = thanksEl.querySelector('[data-codhp-confirm-phone]');
        var totalSpan = thanksEl.querySelector('[data-codhp-confirm-total]');
        if (phoneSpan && phoneInput) phoneSpan.textContent = phoneInput.value;
        if (totalSpan && totalEl) totalSpan.textContent = totalEl.textContent;
      }
    }

    var resetEl = root.querySelector('[data-codhp-reset]');
    if (resetEl) {
      resetEl.addEventListener('click', function () {
        root.classList.remove('is-ordered');
        if (formCard) formCard.hidden = false;
        if (thanksEl) thanksEl.hidden = true;
        if (nameInput) nameInput.value = '';
        if (phoneInput) phoneInput.value = '';
        if (addrInput) addrInput.value = '';
        hideErrors();
        if (submitBtn) {
          submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
          refreshSubmitState();
        }
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        hideErrors();

        var nameOk = nameInput && nameInput.value.trim().length >= 3;
        var phoneOk = phoneInput && /^0\d{8,9}$/.test(phoneInput.value.replace(/[- ]/g, ''));
        var addrOk = addrInput && addrInput.value.trim().length >= 15;

        if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
        if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
        if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);

        if (!nameOk || !phoneOk || !addrOk) {
          if (errEl) errEl.hidden = false;
          return;
        }

        var sel = selectedBundle();
        var variantId = sel && sel.getAttribute('data-variant-id');
        if (!variantId) {
          if (noProductEl) noProductEl.hidden = false;
          return;
        }

        // theme editor: demo the concept thank-you state, no cart mutation
        if (window.Shopify && window.Shopify.designMode) {
          showThanks();
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-label-loading') || submitBtn.textContent;

        var attributes = {
          'ชื่อผู้รับ': nameInput.value.trim(),
          'เบอร์โทร': phoneInput.value.trim(),
          'ที่อยู่จัดส่ง': addrInput.value.trim(),
          'หมายเหตุ': 'แพ็กเกจ: ' + (sel.getAttribute('data-label') || '')
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: Number(sel.getAttribute('data-qty')) || 1 }]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attributes })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('update failed');
            if (window.Panelverse && window.Panelverse.refreshCartCount) window.Panelverse.refreshCartCount();
            window.location.href = '/checkout';
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-label') || submitBtn.textContent;
            if (errNetEl) errNetEl.hidden = false;
          });
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-codhp-root]');
    for (var i = 0; i < roots.length; i++) initCodhp(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-marvel"] && !Shopify.designMode) return;
  try {
    
/* Smooth-scroll every [data-scroll-form] CTA to the COD order form section.
   Target resolution order:
     1. the section id set in "Order form section ID" (data-form-section)
     2. #order
     3. the first [data-cod-form] on the page
   If none of those exist the click falls through to the plain anchor. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-scroll-form]');
  if (!btn) return;

  var root = btn.closest('[data-codmv-root]');
  var sectionId = root ? (root.getAttribute('data-form-section') || '') : '';

  var target = null;
  if (sectionId) {
    target = document.getElementById(sectionId) || document.getElementById('shopify-section-' + sectionId);
  }
  if (!target) target = document.getElementById('order');
  if (!target) target = document.querySelector('[data-cod-form]');
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* COD Marvel lander — bundle selection, FAQ accordion, form validation,
   thank-you state, /cart/add.js → cart attributes → /checkout
   (BUILD_NOTES COD contract). Every lookup is null-guarded, so the same script
   works whether the order form lives in this section or in its own section.
   Countdowns are handled by the shared panelverse.js [data-countdown-to]. */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.getAttribute('data-cod-init')) return;
    root.setAttribute('data-cod-init', '1');

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-cod-bundle]'));
    var totalEl = root.querySelector('[data-cod-total]');
    var submitBtn = root.querySelector('[data-cod-submit]');
    var editorNote = root.querySelector('[data-cod-editor-note]');
    var errorEl = root.querySelector('[data-cod-error]');
    var formCard = root.querySelector('[data-cod-form]');
    var thanksCard = root.querySelector('[data-cod-thanks]');
    var sticky = root.querySelector('[data-cod-sticky]');
    var nameInput = root.querySelector('[data-cod-name]');
    var phoneInput = root.querySelector('[data-cod-phone]');
    var addrInput = root.querySelector('[data-cod-addr]');

    function selected() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return bundles[0] || null;
    }

    function refresh() {
      var sel = selected();
      if (totalEl) totalEl.textContent = sel ? (sel.getAttribute('data-price') || '') : '';
      var hasVariant = sel && sel.getAttribute('data-variant-id');
      if (submitBtn) submitBtn.disabled = !hasVariant;
      if (editorNote) editorNote.hidden = !!hasVariant;
    }

    function select(id) {
      for (var i = 0; i < bundles.length; i++) {
        bundles[i].classList.toggle('is-selected', bundles[i].getAttribute('data-bundle-id') === id);
      }
      refresh();
    }

    bundles.forEach(function (row) {
      row.addEventListener('click', function () {
        select(row.getAttribute('data-bundle-id'));
      });
    });

    root.querySelectorAll('[data-cod-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn.getAttribute('data-cod-pick'));
      });
    });

    /* FAQ accordion */
    root.querySelectorAll('[data-cod-faq]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.codmv-faq__item');
        var answer = item.querySelector('.codmv-faq__a');
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (answer) answer.hidden = !open;
        var toggle = head.querySelector('.codmv-faq__toggle');
        if (toggle) toggle.textContent = open ? '−' : '+';
      });
    });

    /* clear error highlight on input */
    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        if (errorEl) errorEl.hidden = true;
      });
    });

    function showThanks(phone, total) {
      var phoneOut = root.querySelector('[data-cod-confirm-phone]');
      var totalOut = root.querySelector('[data-cod-confirm-total]');
      if (phoneOut) phoneOut.textContent = phone;
      if (totalOut) totalOut.textContent = total;
      if (formCard) formCard.hidden = true;
      if (thanksCard) thanksCard.hidden = false;
      if (sticky) sticky.hidden = true;
    }

    function resetForm() {
      if (nameInput) nameInput.value = '';
      if (phoneInput) phoneInput.value = '';
      if (addrInput) addrInput.value = '';
      if (formCard) formCard.hidden = false;
      if (thanksCard) thanksCard.hidden = true;
      if (sticky) sticky.hidden = false;
      select(root.getAttribute('data-default-bundle'));
    }

    var resetLink = root.querySelector('[data-cod-reset]');
    if (resetLink) resetLink.addEventListener('click', resetForm);

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var sel = selected();
        var name = nameInput ? nameInput.value : '';
        var phone = phoneInput ? phoneInput.value : '';
        var addr = addrInput ? addrInput.value : '';

        /* concept validation, verbatim */
        var nameOk = name.trim().length >= 3;
        var phoneOk = /^0\d{8,9}$/.test(phone.replace(/[- ]/g, ''));
        var addrOk = addr.trim().length >= 15;

        if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
        if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
        if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);

        if (!nameOk || !phoneOk || !addrOk) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        if (errorEl) errorEl.hidden = true;

        var variantId = sel ? sel.getAttribute('data-variant-id') : null;
        var qty = sel ? parseInt(sel.getAttribute('data-qty') || '1', 10) : 1;
        var total = sel ? (sel.getAttribute('data-price') || '') : '';
        var label = sel ? (sel.getAttribute('data-label') || '') : '';

        showThanks(phone, total);
        if (!variantId) return; /* no product wired — CTA is disabled in that state anyway */

        submitBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  'ชื่อผู้รับ': name.trim(),
                  'เบอร์โทร': phone.trim(),
                  'ที่อยู่จัดส่ง': addr.trim(),
                  'หมายเหตุ': label
                }
              })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('update failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            /* offline / preview — stay on the thank-you state */
            submitBtn.disabled = false;
          });
      });
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-codmv-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-spiderman"] && !Shopify.designMode) return;
  try {
    
/* COD Spider-Man lander — CTA scroll + FAQ accordion.
   Countdowns are handled by the shared panelverse.js [data-countdown-to] contract.

   NOTE: the built-in COD order form was removed from this section, so the JS that
   drove it (bundle select, validation, thank-you state, /cart/add.js) is gone too.
   Ordering now runs through the EasySell app block. If the built-in form ever comes
   back, restore its markup AND its variable declarations together — the previous
   version kept the handlers after the markup was deleted, which threw a
   ReferenceError on every page load and killed everything below it. */
(function () {
  'use strict';

  /* ---- CTA → COD form -------------------------------------------------- */
  /* Resolve the form at click time. Never hard-code a section id: Shopify builds
     it as shopify-section-template--<TEMPLATE ID>__<section key>, and the template
     id differs on every template — a copied id silently resolves to null. */
  function codFormEl() {
    return document.querySelector('#es-form-container')    /* EasySell app block  */
        || document.querySelector('.es-form-container')
        || document.getElementById('es-form-hook')         /* EasySell app embed  */
        || document.querySelector('#codsp-order')          /* this section's own form, if restored */
        || document.querySelector('.codsp-form');
  }

  /* A bar pinned to the top would otherwise cover the form heading. */
  function headroom() {
    var bars = document.querySelectorAll('.codsp-topbar, .codsp-header, header');
    var h = 0;
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i], cs = window.getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 4 && r.height) {
        h = Math.max(h, r.height);
      }
    }
    return h;
  }

  function targetY(el, offset) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.max(0, Math.min(top, max));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-scroll-form]') : null;
    if (!btn) return;

    var target = codFormEl();
    if (!target) return;   /* nothing to scroll to — leave the link alone rather than
                              swallowing the click with a preventDefault that leads nowhere */

    e.preventDefault();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var offset = headroom() + 16;
    var want = targetY(target, offset);
    var from = window.pageYOffset;

    if (reduce) {
      window.scrollTo(0, want);
      return;
    }

    try {
      window.scrollTo({ top: want, behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, want);
      return;
    }

    /* Smooth scrolling is suspended in a background tab and in a few older browsers,
       which would leave the tap doing nothing at all. Land late rather than not land. */
    window.setTimeout(function () {
      if (Math.abs(window.pageYOffset - from) < 4 && Math.abs(want - from) > 4) {
        window.scrollTo(0, targetY(target, offset));
      }
    }, 450);
  });

  /* ---- FAQ accordion --------------------------------------------------- */
  function initRoot(root) {
    if (root.getAttribute('data-cod-init')) return;
    root.setAttribute('data-cod-init', '1');

    root.querySelectorAll('[data-cod-faq]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.codsp-faq__item');
        if (!item) return;
        var answer = item.querySelector('.codsp-faq__a');
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (answer) answer.hidden = !open;
        var toggle = head.querySelector('.codsp-faq__toggle');
        if (toggle) toggle.textContent = open ? '−' : '+';
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-codsp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-star-wars"] && !Shopify.designMode) return;
  try {
    
/* Smooth-scroll every [data-scroll-form] CTA to the COD order form section.
   Target resolution order:
     1. the section id set in "Order form section ID" (data-form-section)
     2. #codsw-order
     3. the first [data-codsw-form] on the page
   If none of those exist the click falls through to the plain anchor. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-scroll-form]');
  if (!btn) return;

  var root = btn.closest('[data-codsw]');
  var sectionId = root ? (root.getAttribute('data-form-section') || '') : '';

  var target = null;
  if (sectionId) {
    target = document.getElementById(sectionId) || document.getElementById('shopify-section-' + sectionId);
  }
  if (!target) target = document.getElementById('codsw-order');
  if (!target) target = document.querySelector('[data-codsw-form]');
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* Star Wars COD lander — bundle selection, FAQ accordion, COD form.
   Submit flow (BUILD_NOTES): /cart/add.js -> cart attributes -> /checkout.
   If the cart calls fail (offline/preview), falls back to the concept's
   thank-you state so the page still completes. Every lookup is null-guarded, so
   the same script works whether the order form lives in this section or in its
   own section. */
(function () {
  'use strict';

  function initCodsw(root) {
    if (!root || root.hasAttribute('data-codsw-init')) return;
    root.setAttribute('data-codsw-init', '');

    var addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
    var updateUrl = root.getAttribute('data-update-url') || '/cart/update.js';
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-codsw-bundle]'));
    var totalEl = root.querySelector('[data-codsw-total]');
    var submitBtn = root.querySelector('[data-codsw-submit]');
    var errorEl = root.querySelector('[data-codsw-error]');
    var noProductEl = root.querySelector('[data-codsw-noproduct]');
    var formCard = root.querySelector('[data-codsw-form]');
    var thanksCard = root.querySelector('[data-codsw-thanks]');
    var nameInput = root.querySelector('[data-codsw-name]');
    var phoneInput = root.querySelector('[data-codsw-phone-input]');
    var addrInput = root.querySelector('[data-codsw-addr]');

    /* ---- bundle selection ---- */
    function selected() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return null;
    }

    function select(el) {
      if (!el) return;
      bundles.forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (totalEl) totalEl.textContent = el.getAttribute('data-price') || '';
      var hasVariant = !!el.getAttribute('data-variant-id');
      if (submitBtn) submitBtn.disabled = !hasVariant;
      if (noProductEl) noProductEl.hidden = hasVariant;
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (ev) {
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); select(b); }
      });
    });

    root.querySelectorAll('[data-codsw-pick]').forEach(function (a) {
      a.addEventListener('click', function () {
        var idx = a.getAttribute('data-codsw-pick');
        var target = root.querySelector('[data-codsw-bundle="' + idx + '"]');
        if (target) select(target);
      });
    });

    select(root.querySelector('[data-codsw-bundle][data-popular]') || bundles[0]);

    /* ---- FAQ accordion (one open at a time, +/-) ---- */
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-codsw-faq]'));
    faqItems.forEach(function (item) {
      var btn = item.querySelector('[data-codsw-faq-toggle]');
      var answer = item.querySelector('.codsw-faq__a');
      var icon = item.querySelector('.codsw-faq__icon');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var oa = other.querySelector('.codsw-faq__a');
          var ob = other.querySelector('[data-codsw-faq-toggle]');
          var oi = other.querySelector('.codsw-faq__icon');
          if (oa) oa.hidden = true;
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (oi) oi.textContent = '+';
        });
        if (willOpen) {
          item.classList.add('is-open');
          answer.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '−';
        }
      });
    });

    /* ---- validation (concept rules, verbatim) ---- */
    function validate() {
      var nameOk = nameInput && nameInput.value.trim().length >= 3;
      var phoneOk = phoneInput && /^0\d{8,9}$/.test(phoneInput.value.replace(/[- ]/g, ''));
      var addrOk = addrInput && addrInput.value.trim().length >= 15;
      if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
      if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
      if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);
      return nameOk && phoneOk && addrOk;
    }

    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        if (errorEl) errorEl.hidden = true;
      });
    });

    /* ---- thank-you state ---- */
    function showThanks() {
      root.classList.add('is-ordered');
      if (formCard) formCard.hidden = true;
      if (thanksCard) thanksCard.hidden = false;
      var ph = root.querySelector('[data-codsw-thanks-phone]');
      var tt = root.querySelector('[data-codsw-thanks-total]');
      if (ph && phoneInput) ph.textContent = phoneInput.value;
      if (tt && totalEl) tt.textContent = totalEl.textContent;
      if (thanksCard) thanksCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    var resetBtn = root.querySelector('[data-codsw-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        root.classList.remove('is-ordered');
        if (formCard) formCard.hidden = false;
        if (thanksCard) thanksCard.hidden = true;
        if (nameInput) nameInput.value = '';
        if (phoneInput) phoneInput.value = '';
        if (addrInput) addrInput.value = '';
        select(root.querySelector('[data-codsw-bundle][data-popular]') || bundles[0]);
      });
    }

    /* ---- submit: add.js -> attributes -> /checkout ---- */
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!validate()) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        if (errorEl) errorEl.hidden = true;
        var sel = selected();
        var variantId = sel ? sel.getAttribute('data-variant-id') : '';
        if (!variantId) {
          if (noProductEl) noProductEl.hidden = false;
          return;
        }
        var qty = parseInt(sel.getAttribute('data-quantity'), 10) || 1;
        var attrs = {
          'ชื่อผู้รับ': nameInput.value.trim(),
          'เบอร์โทร': phoneInput.value.trim(),
          'ที่อยู่จัดส่ง': addrInput.value.trim(),
          'หมายเหตุ': 'แพ็กเกจ: ' + (sel.getAttribute('data-label') || '')
        };
        submitBtn.disabled = true;
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty })
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch(updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        }).then(function (res) {
          if (!res.ok) throw new Error('update failed');
          if (window.Panelverse && window.Panelverse.refreshCartCount) window.Panelverse.refreshCartCount();
          window.location.href = '/checkout';
        }).catch(function () {
          submitBtn.disabled = false;
          showThanks();
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-codsw]').forEach(initCodsw);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cod-superman"] && !Shopify.designMode) return;
  try {
    
/* Smooth-scroll every [data-scroll-form] CTA to the COD order form section.
   Target resolution order:
     1. the section id set in "Order form section ID" (data-form-section)
     2. #codsm-order
     3. the first [data-codsm-form] on the page
   If none of those exist the click falls through to the plain anchor. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-scroll-form]');
  if (!btn) return;

  var root = btn.closest('[data-codsm]');
  var sectionId = root ? (root.getAttribute('data-form-section') || '') : '';

  var target = null;
  if (sectionId) {
    target = document.getElementById(sectionId) || document.getElementById('shopify-section-' + sectionId);
  }
  if (!target) target = document.getElementById('codsm-order');
  if (!target) target = document.querySelector('[data-codsm-form]');
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

/* Superman COD lander — bundle selection, FAQ accordion, COD form.
   Submit flow (BUILD_NOTES): /cart/add.js -> cart attributes -> /checkout.
   If the cart calls fail (offline/preview), falls back to the concept's
   thank-you state so the page still completes. Every lookup is null-guarded, so
   the same script works whether the order form lives in this section or in its
   own section. */
(function () {
  'use strict';

  function initCodsm(root) {
    if (!root || root.hasAttribute('data-codsm-init')) return;
    root.setAttribute('data-codsm-init', '');

    var addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
    var updateUrl = root.getAttribute('data-update-url') || '/cart/update.js';
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-codsm-bundle]'));
    var totalEl = root.querySelector('[data-codsm-total]');
    var submitBtn = root.querySelector('[data-codsm-submit]');
    var errorEl = root.querySelector('[data-codsm-error]');
    var noProductEl = root.querySelector('[data-codsm-noproduct]');
    var formCard = root.querySelector('[data-codsm-form]');
    var thanksCard = root.querySelector('[data-codsm-thanks]');
    var nameInput = root.querySelector('[data-codsm-name]');
    var phoneInput = root.querySelector('[data-codsm-phone-input]');
    var addrInput = root.querySelector('[data-codsm-addr]');

    /* ---- bundle selection ---- */
    function selected() {
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].classList.contains('is-selected')) return bundles[i];
      }
      return null;
    }

    function select(el) {
      if (!el) return;
      bundles.forEach(function (b) {
        var on = b === el;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (totalEl) totalEl.textContent = el.getAttribute('data-price') || '';
      var hasVariant = !!el.getAttribute('data-variant-id');
      if (submitBtn) submitBtn.disabled = !hasVariant;
      if (noProductEl) noProductEl.hidden = hasVariant;
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (ev) {
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); select(b); }
      });
    });

    root.querySelectorAll('[data-codsm-pick]').forEach(function (a) {
      a.addEventListener('click', function () {
        var idx = a.getAttribute('data-codsm-pick');
        var target = root.querySelector('[data-codsm-bundle="' + idx + '"]');
        if (target) select(target);
      });
    });

    select(root.querySelector('[data-codsm-bundle][data-popular]') || bundles[0]);

    /* ---- FAQ accordion (one open at a time, +/-) ---- */
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-codsm-faq]'));
    faqItems.forEach(function (item) {
      var btn = item.querySelector('[data-codsm-faq-toggle]');
      var answer = item.querySelector('.codsm-faq__a');
      var icon = item.querySelector('.codsm-faq__icon');
      if (!btn || !answer) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var oa = other.querySelector('.codsm-faq__a');
          var ob = other.querySelector('[data-codsm-faq-toggle]');
          var oi = other.querySelector('.codsm-faq__icon');
          if (oa) oa.hidden = true;
          if (ob) ob.setAttribute('aria-expanded', 'false');
          if (oi) oi.textContent = '+';
        });
        if (willOpen) {
          item.classList.add('is-open');
          answer.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          if (icon) icon.textContent = '−';
        }
      });
    });

    /* ---- validation (concept rules, verbatim) ---- */
    function validate() {
      var nameOk = nameInput && nameInput.value.trim().length >= 3;
      var phoneOk = phoneInput && /^0\d{8,9}$/.test(phoneInput.value.replace(/[- ]/g, ''));
      var addrOk = addrInput && addrInput.value.trim().length >= 15;
      if (nameInput) nameInput.classList.toggle('is-invalid', !nameOk);
      if (phoneInput) phoneInput.classList.toggle('is-invalid', !phoneOk);
      if (addrInput) addrInput.classList.toggle('is-invalid', !addrOk);
      return nameOk && phoneOk && addrOk;
    }

    [nameInput, phoneInput, addrInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        if (errorEl) errorEl.hidden = true;
      });
    });

    /* ---- thank-you state ---- */
    function showThanks() {
      root.classList.add('is-ordered');
      if (formCard) formCard.hidden = true;
      if (thanksCard) thanksCard.hidden = false;
      var ph = root.querySelector('[data-codsm-thanks-phone]');
      var tt = root.querySelector('[data-codsm-thanks-total]');
      if (ph && phoneInput) ph.textContent = phoneInput.value;
      if (tt && totalEl) tt.textContent = totalEl.textContent;
      if (thanksCard) thanksCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    var resetBtn = root.querySelector('[data-codsm-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        root.classList.remove('is-ordered');
        if (formCard) formCard.hidden = false;
        if (thanksCard) thanksCard.hidden = true;
        if (nameInput) nameInput.value = '';
        if (phoneInput) phoneInput.value = '';
        if (addrInput) addrInput.value = '';
        select(root.querySelector('[data-codsm-bundle][data-popular]') || bundles[0]);
      });
    }

    /* ---- submit: add.js -> attributes -> /checkout ---- */
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!validate()) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        if (errorEl) errorEl.hidden = true;
        var sel = selected();
        var variantId = sel ? sel.getAttribute('data-variant-id') : '';
        if (!variantId) {
          if (noProductEl) noProductEl.hidden = false;
          return;
        }
        var qty = parseInt(sel.getAttribute('data-quantity'), 10) || 1;
        var attrs = {
          'ชื่อผู้รับ': nameInput.value.trim(),
          'เบอร์โทร': phoneInput.value.trim(),
          'ที่อยู่จัดส่ง': addrInput.value.trim(),
          'หมายเหตุ': 'แพ็กเกจ: ' + (sel.getAttribute('data-label') || '')
        };
        submitBtn.disabled = true;
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty })
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch(updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        }).then(function (res) {
          if (!res.ok) throw new Error('update failed');
          if (window.Panelverse && window.Panelverse.refreshCartCount) window.Panelverse.refreshCartCount();
          window.location.href = '/checkout';
        }).catch(function () {
          submitBtn.disabled = false;
          showThanks();
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-codsm]').forEach(initCodsm);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-drop-countdown"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (ev) {
  var wish = ev.target && ev.target.closest ? ev.target.closest('[data-drop-wish]') : null;
  if (wish) {
    wish.classList.toggle('is-wished');
    return;
  }
  var notify = ev.target && ev.target.closest ? ev.target.closest('[data-drop-notify]') : null;
  if (notify) {
    var on = notify.classList.toggle('is-on');
    notify.textContent = on
      ? (notify.getAttribute('data-label-done') || 'ON THE LIST ✓')
      : (notify.getAttribute('data-label') || 'NOTIFY ME');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-explore"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (ev) {
  var opt = ev.target && ev.target.closest ? ev.target.closest('[data-vote-opt]') : null;
  if (!opt) return;
  var card = opt.closest('[data-vote]');
  if (!card || opt.classList.contains('is-voted')) return;

  var opts = card.querySelectorAll('[data-vote-opt]');
  var total = 0;
  var i;
  for (i = 0; i < opts.length; i++) {
    var el = opts[i];
    var v = Number(el.getAttribute('data-votes')) || 0;
    if (el.classList.contains('is-voted')) v -= 1; // retract previous vote
    el.setAttribute('data-votes', String(v));
    el.classList.remove('is-voted');
  }
  opt.setAttribute('data-votes', String((Number(opt.getAttribute('data-votes')) || 0) + 1));
  opt.classList.add('is-voted');

  for (i = 0; i < opts.length; i++) total += Number(opts[i].getAttribute('data-votes')) || 0;
  for (i = 0; i < opts.length; i++) {
    var votes = Number(opts[i].getAttribute('data-votes')) || 0;
    var pct = total ? Math.round((votes / total) * 100) : 0;
    opts[i].querySelector('.home-explore__vote-fill').style.width = pct + '%';
    var pctEl = opts[i].querySelector('[data-vote-pct]');
    if (pctEl) pctEl.textContent = pct + '%';
  }
  var hint = card.querySelector('[data-vote-hint]');
  if (hint) hint.textContent = total.toLocaleString() + ' ' + (hint.getAttribute('data-hint-voted') || 'collectors have voted');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (ev) {
  var toggle = ev.target && ev.target.closest ? ev.target.closest('[data-faq-toggle]') : null;
  if (!toggle) return;
  var item = toggle.closest('[data-faq]');
  var list = toggle.closest('[data-faq-list]');
  if (!item || !list) return;
  var wasOpen = item.classList.contains('is-open');
  var items = list.querySelectorAll('[data-faq]');
  for (var i = 0; i < items.length; i++) {
    items[i].classList.remove('is-open');
    items[i].querySelector('[data-faq-answer]').hidden = true;
    items[i].querySelector('[data-faq-icon]').textContent = '+';
    items[i].querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
  }
  if (!wasOpen) {
    item.classList.add('is-open');
    item.querySelector('[data-faq-answer]').hidden = false;
    item.querySelector('[data-faq-icon]').textContent = '−';
    toggle.setAttribute('aria-expanded', 'true');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (ev) {
  var panel = ev.target && ev.target.closest ? ev.target.closest('[data-hero-panel]') : null;
  if (!panel) return;
  var stage = panel.closest('.home-hero__stage');
  if (!stage) return;
  var panels = stage.querySelectorAll('[data-hero-panel]');
  for (var i = 0; i < panels.length; i++) panels[i].classList.remove('is-top');
  panel.classList.add('is-top');
});

  } catch(e) { console.error(e); }
})();
})();
